import { Component, Input, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { SurveyService } from '../../service/survey.service';
import { SendMailData, SendMailEmails } from '../../types/send-mails';

type Emails = {
  left: SendMailEmails[]
  right: SendMailEmails[]
}

type PopupData = SendMailData & {
  ref: NgbModalRef
} 

@Component({
  selector: 'app-send-mail-modal',
  templateUrl: './send-mail-modal.component.html',
  styleUrls: ['./send-mail-modal.component.scss']
})
export class SendMailModalComponent implements OnInit {
  @Input() data: PopupData;
  emails: Emails;
  filterText: string = "";
  allEmailText: string = 'All';

  constructor(private notifier:NotifierService, private surveyService: SurveyService) { }

  ngOnInit(): void {
    this.init();
  }

  init() {
    if(!this.data.surveys) this.data.surveys = [];
    this.data.surveys = this.data.surveys.map(e => ({...e, checked: true}))

    if(this.data.emails && this.data.emails.length) {
      // Adding All checkbox
      let hasAllIndex = this.data.emails.findIndex(t=> t.email === this.allEmailText)
      if(hasAllIndex < 0) {
        this.data.emails.unshift({email: this.allEmailText, checked: false, survey_email_map_id: 0})
      }

      this.data.emails = this.data.emails.map((e, index) => ({...e, index: index}));
      this.emailChecked({checked: this.data.emails[1].checked}, this.data.emails[1].email, 1);
    } else this.data.emails = [];
  }

  emailChecked(currentTarget: any, email: string, index: number = 0) {

    let checked = currentTarget.checked;
    if(email == this.allEmailText) this.data.emails = this.data.emails.map(e => ({...e, checked: checked}))
    else {
      if(this.data.emails[index]) this.data.emails[index].checked = checked;
      let isAllChecked = checked && (this.data.emails.every(e => e.email == this.allEmailText ? true : e.checked)) || false;

      if(this.data.emails[0].email == this.allEmailText) {
        if(isAllChecked && !this.data.emails[0].checked) this.data.emails[0].checked = true;
        if(!isAllChecked && this.data.emails[0].checked) this.data.emails[0].checked = false;
      }
    }
    this.filterMails();
  }

  filterMails() {
    this.setMailDefaults();
    for(let el of this.data.emails) {
      if(this.filterText && (!el.email.toLowerCase().includes(this.filterText.toLowerCase()) || el.email === this.allEmailText)) continue;
      if(this.emails.left.length === this.emails.right.length) this.emails.left.push(el);
      else this.emails.right.push(el);
    }
  }

  setMailDefaults() {
    this.emails = {left: [], right: []};
  }

  surveyChecked(currentTarget: any, surveyId: string, surveyEmailMapIds: number[]) {
    let checked = currentTarget.checked;
    this.data.surveys = this.data.surveys.map(el => (el.id == surveyId) && ({...el, checked: checked}) || el);
    
    for (let surveyEmailMapId of surveyEmailMapIds) {
      let shouldEmailsCheckChange = this.data.surveys
        .filter(s => s.survey_email_map_id.includes(surveyEmailMapId))
        [checked ? 'some' : 'every'](s => (s.checked == checked))
  
      if(shouldEmailsCheckChange) this.changeEmailsCheckBasedOnSurvey(surveyEmailMapId, checked)
    }

    if(checked && this.surveyService.isAllOrg()) {
      this.data.emails = this.data.emails.map(emailObj => {
        if(!surveyEmailMapIds.includes(emailObj.survey_email_map_id)) return emailObj
        
        let initialStateOfEmail = this.surveyService.sendMailData?.emails.find(e=> e.email === emailObj.email)
        return {...emailObj, checked: initialStateOfEmail?.checked!}
      })
      this.filterMails()
    }
    if(!checked) this.isAllSurveyUncheckedOperation()
  }

  changeEmailsCheckBasedOnSurvey(surveyEmailMapId: number, checked: boolean) {
    let params: SendMailEmails | undefined;

    this.data.emails = this.data.emails.map((e, index) => {
      let item = {...e}
      if(e.survey_email_map_id == surveyEmailMapId) {
        item['checked'] = checked;
        if(!params) params = {...item, index: index}
      }
      return item;
    })
    if(params) this.emailChecked(params, params.email, params.index)
  }

  isAllSurveyUncheckedOperation() {
    let isUnchecked = this.data.surveys.find(s => s.checked)
    if(!isUnchecked) {
      this.emailChecked({checked: false}, this.allEmailText, 0)
    }
  }

  sendMail() {
    let selectedEmails = this.data.emails.filter(el => (el.email != this.allEmailText && el.checked)).map(el => el.email);
    let selectedSurveys = this.data.surveys.filter(el => el.checked).map(el => el.id);

    if(!selectedSurveys.length) return this.notifier.notify('error', "Please Choose atleaset one study to share");
    if(!selectedEmails.length) return this.notifier.notify('error', "Please Choose atleaset one email to share");

    this.surveyService.sendNewlyAddedSurveysMail({emails: selectedEmails, survey_data: selectedSurveys})
    .subscribe(({ data, error }) => {
      if(data) {
        if(data.status == 1) {
          this.notifier.notify('success', data.message);
          this.close();
          this.surveyService.sendMailData = undefined;
        } else if(data.status == 2) {
          this.notifier.notify('info', data.message);
        } else this.notifier.notify('error', data.message);

      } else this.notifier.notify('error', "Could Not Send Mail, Please Try again");
    });
  }

  close() {
    this.setMailDefaults();
    this.data.surveys = [];
    if(this.data.ref) this.data.ref.close();
    this.filterText = "";
  }

}
